import type { ErrorLike } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import type { GraphQLFormattedError } from 'graphql';

export function getFormattedErrorFromGraphQLError(
  error: ErrorLike,
): ReadonlyArray<GraphQLFormattedError> {
  if (CombinedGraphQLErrors.is(error)) {
    return error.errors;
  }

  return [error];
}
